import { render, staticRenderFns } from "./staff-manage.vue?vue&type=template&id=0171c0ea&scoped=true&"
import script from "./staff-manage.vue?vue&type=script&lang=js&"
export * from "./staff-manage.vue?vue&type=script&lang=js&"
import style0 from "./staff-manage.vue?vue&type=style&index=0&id=0171c0ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0171c0ea",
  null
  
)

export default component.exports